export default {
  header: 'Tällä viikolla',
  metrics: {
    points: 'Pisteet',
    visits: 'Käynnit',
    in_store_sign_ups: 'Rekisteröitymiset paikan päällä',
    rewards_redeemed: 'Lunastetut palkinnot',
  },
};
